import domready from 'domready'
import SubnavBarController from './controllers/subnav-bar-controller'

export default function initStoryController () {
  domready(() => {
    const element = document.querySelector('.subnav-bar')
    if (element) {
      // eslint-disable-next-line no-new
      new SubnavBarController(element)
    }
  })
}
